import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RelatorioVisualizadorComponent } from './relatorio-visualizador/relatorio-visualizador.component';
import { DialogAllModule } from '@syncfusion/ej2-angular-popups';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { RelatorioService } from './relatorio.service';



@NgModule({
  declarations: [
    RelatorioVisualizadorComponent
  ],
  imports: [
    CommonModule,
    DialogAllModule,
    NgxExtendedPdfViewerModule,
  ],
  exports: [
    RelatorioVisualizadorComponent
  ],
  providers: [
    RelatorioService
  ]
})
export class RelatorioModule { }
